/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Camera_Field_Control_HintInputs */

const vi_grower_area_camera_field_control_hint = /** @type {(inputs: Grower_Area_Camera_Field_Control_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống nếu camera không quay được — thẻ sẽ hiện nhãn "Chỉ xem".`)
};

/**

* @param {Grower_Area_Camera_Field_Control_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_camera_field_control_hint = /** @type {((inputs?: Grower_Area_Camera_Field_Control_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Camera_Field_Control_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_camera_field_control_hint(inputs)
});